import * as React from 'react';
export const billableItemSvg = React.forwardRef(function billableItemSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.444 1.888a.75.75 0 0 1 1.483.224l-1.816 12a.75.75 0 1 1-1.483-.224l1.816-12Zm5.447 0a.75.75 0 0 1 1.484.224l-1.817 12a.75.75 0 1 1-1.482-.224l1.815-12Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14 4.293a.75.75 0 0 1 0 1.5H2.948a.75.75 0 1 1 0-1.5H14Zm-.948 5.913a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1 0-1.5h11.052Z',
    }),
  );
});
billableItemSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var billableItem = {
  category: 'icon',
  colorable: true,
  name: 'billableItem',
  svg: billableItemSvg,
};
